// extracted by mini-css-extract-plugin
export default {"image":"AvatarUpload_image__6ItMq","square":"AvatarUpload_square__dDREv","uploadButton":"AvatarUpload_uploadButton__dLkcU"};